import { AtendimentoType, ModalidadeType, VinculoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type RelatorioNpsFilters = {
  empresa?: IOption<number>
  /** Depende da instituição (é limpa quando a instituição sai). */
  unidade?: IOption<number>
  /** Período: campo de data ("Consultas entre") + início/fim (aaaa-mm-dd). */
  range?: IOption<string>
  inicio: string
  fim: string
  paciente: string
  protocolo: string
  especialidade?: IOption<number>
  vinculo?: IOption<VinculoType>
  estado?: IOption<number>
  profissional?: IOption<number>
  tipoAtendimento?: IOption<AtendimentoType>
  modalidade?: IOption<ModalidadeType>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<RelatorioNpsFilters>({
  empresa: undefined,
  unidade: undefined,
  range: undefined,
  inicio: '',
  fim: '',
  paciente: '',
  protocolo: '',
  especialidade: undefined,
  vinculo: undefined,
  estado: undefined,
  profissional: undefined,
  tipoAtendimento: undefined,
  modalidade: undefined,
})
